import './ModalPreview.scss'

import React from 'react';
import Modal from 'react-modal';

import H3 from 'components/H3';
import Icon from 'components/Icon';

import { FILE_TYPES, MODAL_STYLE_RESET } from 'utils/constants';

export default class ModalPreview extends React.Component {
    static propTypes = {
        className: React.PropTypes.string,
        contentPiece: React.PropTypes.object.isRequired,
        handleClose: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired
    };

    _generateContentHmtl() {
        let { contentPiece } = this.props;
        switch(contentPiece.type) {
            case 'file':
                let contentTypeString = FILE_TYPES[contentPiece.file.contentType];
                if(contentTypeString === 'Image') {
                    return <img src={`${process.env.API_URL}rest/file/${contentPiece.file.id}`} alt={contentPiece.name} />;
                } else {
                    return (
                        <a className="file-download--wrapper" href={`${process.env.API_URL}rest/file/${contentPiece.file.id}`}>
                            <div className="file-download__info">
                                <H3>{contentPiece.name}</H3>
                                <div className="file-download__type">
                                    {contentTypeString}
                                </div>
                                <div className="file-download__instructions">
                                    Click to download file
                                </div>
                            </div>
                            <div className="file-download__icon">
                                <Icon icon="download" />
                            </div>
                        </a>
                    )
                }
            case 'html':
                return (
                    <div className="document__content" dangerouslySetInnerHTML={{__html: contentPiece.content}} />
                );
            default:
                return null;
        }
    }

    render() {
        let { className, contentPiece, handleClose, show } = this.props;
        let styles = JSON.parse(JSON.stringify(MODAL_STYLE_RESET));
        styles.overlay.zIndex = 102;
        if(Object.keys(contentPiece).length > 0) {
            return (
                <Modal isOpen={show}
                       style={styles}
                       className={`preview-modal ${className || ''} ${contentPiece.type}`}
                       contentLabel="Modal"
                       onRequestClose={this._handleClose}>
                    <div role="button"
                         className="modal__close"
                         onClick={handleClose.bind(this)}>
                        <Icon icon="close"/>
                    </div>
                    <div className="preview-modal--inner">
                        {this._generateContentHmtl()}
                    </div>
                </Modal>
            )
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalPreview/index.js